import { ReactNode, useContext } from 'react'
import { SViewProps } from '.'
import { useScale } from '../../utils/scaleUtils'
import { ExplorerConfigContext } from '../providers'
import SView from './SView'

export interface Props extends Omit<SViewProps, 'children' | 'h' | 'w'> {
  Icon: (props: any) => ReactNode
  /** (default 38) */
  size?: number
}

export default function SIconCircle({ size = 38, Icon, ...rest }: Props) {
  const { theme } = useContext(ExplorerConfigContext)
  const scale = useScale()

  return (
    <SView
      alignItems="center"
      background="rgba(255, 255, 255, 0.20)"
      borderRadius={999}
      boxShadow="0px 4px 10px 0px rgba(0, 0, 0, 0.06)"
      flexShrink={0}
      h={size}
      justifyContent="center"
      w={size}
      {...rest}
    >
      <Icon color={theme.color.primary} size={size * 0.6 * scale} />
    </SView>
  )
}
